/**
 * Builds the login redirect URL for the given side of the app.
 *
 * TODO: `redirect_to` was dropped here — investigate whether Auth0 supports
 * redirecting back to the original page post-login before reintroducing it.
 */
export function getLoginUrl(kind: 'system' | 'client'): string {
    return kind === 'system' ? '/api/system/auth/login' : '/api/auth/login';
}

/**
 * Logout the current user by calling the logout API.
 * This will redirect to Auth0 logout and then back to the app.
 */
export async function logout(): Promise<void> {
    const response = await fetch('/api/auth/logout', {
        method: 'POST',
        redirect: 'manual',
    });

    // The server returns a redirect to Auth0 logout
    // With redirect: 'manual', we get the redirect URL from the response
    if (response.type === 'opaqueredirect' || response.status === 302) {
        // For opaque redirects, we need to navigate manually
        // The cookie is already cleared, so just go to the login page
        window.location.href = getLoginUrl('client');
    } else if (response.redirected) {
        window.location.href = response.url;
    } else {
        // Fallback: just reload to trigger auth check
        window.location.href = getLoginUrl('client');
    }
}

/**
 * Logout the current system user by calling the system logout API.
 * This will redirect to Auth0 logout and then back to the system app.
 */
export async function systemLogout(): Promise<void> {
    const response = await fetch('/api/system/auth/logout', {
        method: 'POST',
        redirect: 'manual',
    });

    // The server returns a redirect to Auth0 logout
    // With redirect: 'manual', we get the redirect URL from the response
    if (response.type === 'opaqueredirect' || response.status === 302) {
        // For opaque redirects, we need to navigate manually
        // The cookie is already cleared, so just go to the system login page
        window.location.href = getLoginUrl('system');
    } else if (response.redirected) {
        window.location.href = response.url;
    } else {
        // Fallback: just reload to trigger auth check
        window.location.href = getLoginUrl('system');
    }
}
